import {countBy} from 'lodash';


function twoPair(hand){

	var found = false;
	var values = countBy(hand.byValue);
	var wilds = values[20];

	var value1 = 14;
	var value2 = 13;
	while(!found && value1 >= 3){
		if(values[value1] + wilds >= 2){
			if(values[value1] < 2){
				wilds -= 2 - values[value1];
			}
			//second pair
			while(!found && value2 >= 2){
				if(values[value2] + wilds >= 2){
					found = [value1, value2];
				} else {
					value2--;
				}
			}

		}
		if(!found){
			value1--;
			value2 = value1 -1;
		}
	}

	if(found){
		//create the match value, need to decide what this would be best served as.
		console.log(found);
	}

	return {best: false, match: []};

}

export function handEval(hand){
	var result = {best: false, match: []}

	switch (hand.goal) {
		case 'two-pair':
			result = twoPair(hand);
			break;

		default:
			break;
	}

	return result;

}